module.exports = __webpack_public_path__ + "r-v3/img/timer.90c646f0.svg";